RivalIQ.apps.CompanyProfile.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.AddPageModal = Marionette.ItemView.mixin({
        template: '#companyProfilePagesAddPageModalTemplate',
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        ui: {
            modal: '.modal',
            formGroup: '#addPageModalForm .form-group',
            inputField: '#addPageModalForm input',
            submitBtn: '#btnAddFollowedCompany',
            statusMessage: '#addPageModalForm label'
        },

        events: {
            'click @ui.submitBtn': 'addPageUrl',
            'keypress @ui.inputField': 'urlFieldKeypress',
            'shown.bs.modal @ui.modal': 'onModalShown'
        },

        onModalShown: function () {
            const me = this;
            me.ui.inputField.focus();
        },

        urlFieldKeypress: function (e) {
            if (e.which === 13) {
                const me = this;

                e.preventDefault();
                me.addPageUrl();
            }
        },

        clearMessages: function () {
            const me = this;
            me.ui.formGroup.removeClass('has-success has-error');
            me.ui.statusMessage.html();
            me.ui.submitBtn.button('reset');
        },

        displayError: function (error) {
            const me = this;
            me.ui.formGroup.addClass('has-error');
            me.ui.statusMessage.html(error);
            me.ui.submitBtn.button('reset');
        },

        addPageUrl: function () {
            const me = this;
            const url = $.trim(me.ui.inputField.val());
            me.ui.submitBtn.button('loading');

            if (!url) {
                me.displayError('Please fill in the URL field and try again.');
                return;
            }

            me.dashboardModel.configuration.appendDefinition(url)
                .fail(function () {
                    me.displayError('We had an error adding that page.  Please try again.');
                })
                .done(function () {
                    RivalIQ.execute('alert:info', `Page submitted. We're adding it now.`);
                    me.ui.modal.modal('hide');
                    me.ui.inputField.val('');
                    me.clearMessages();
                });
        }
    });
});
